<template>
  <!-- TODO: make this a single reuseable component-->
  <md-dialog :md-active.sync="isVisible" v-if="submission">
    <md-dialog-title>
      Update Submission Details ({{ submission.product.lender_name }}:
      {{ submission.product.product_name }})
    </md-dialog-title>
    <md-dialog-content>
      <template v-if="application.loan.asset.type == 'Personal'">
        <md-subheader>Asset Value</md-subheader>
        <div class="md-layout">
          <!-- Requested Amount -->
          <validated-number-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Requested Amount"
            prefix="$"
            v-model="security.requested_amount"
          >
          </validated-number-input>
        </div>
      </template>
      <template v-if="isWithOtherFields">
        <md-subheader>Asset Costs</md-subheader>

        <div class="md-layout">
          <!-- Purchase Cost -->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Purchase Cost"
            prefix="$"
            v-model="security.purchase_cost"
            type="CURRENCY"
          />

          <!-- Accessories -->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Extra Costs"
            prefix="$"
            v-model="security.accessories_cost"
            type="CURRENCY"
          />

          <!-- Deposit -->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Deposit"
            prefix="$"
            v-model="security.deposit_value"
            type="CURRENCY"
          />

          <!-- Trade In Calculated from the trade in value from assets-->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Trade In"
            prefix="$"
            v-model="trade_in_asset_value"
            type="CURRENCY"
            :disabled="!enable_trade_in_asset_value"
          />

          <!-- Finance Outstanding -->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Finance Outstanding"
            prefix="$"
            v-model="trade_in_asset_outstanding_amount"
            type="CURRENCY"
            :disabled="!enable_trade_in_asset_outstanding_amount"
          />

          <!-- Total Asset Cost -->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Total Asset Cost (calculated)"
            prefix="$"
            :value="total_requested_amount"
            type="CURRENCY"
            disabled
          />
        </div>
      </template>
      <md-subheader>Fees</md-subheader>
      <div class="md-layout">
        <!-- Document Origination Fee -->
        <validated-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="DOF"
          :disabled="isComplianceFail"
          prefix="$"
          v-model="submission.document_origination_fee"
          type="CURRENCY"
        />

        <!-- Establishment Fee -->
        <validated-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Establishment Fee"
          prefix="$"
          :disabled="isComplianceFail"
          v-model="submission.establishment_fee"
          type="CURRENCY"
        />

        <!-- PPSR Fee -->
        <validated-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="PPSR Fee"
          prefix="$"
          :disabled="isComplianceFail"
          v-model="submission.ppsr_fee"
          type="CURRENCY"
        />

        <!-- Risk Fee -->
        <validated-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Risk Fee"
          prefix="$"
          :disabled="isComplianceFail"
          v-model="submission.risk_fee"
          type="CURRENCY"
        />

        <!-- Total Fees -->
        <validated-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Total Fees (calculated)"
          prefix="$"
          :value="total_fees"
          type="CURRENCY"
          disabled
        />

        <!-- Lender Commission -->
        <validated-input type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-15"
          label="Commission Inc in NAF (calculated)"
          prefix="$"
          readonly
          v-model="get_lender_commission_amount"
          disabled
        />

        <!-- Insurances -->
        <validated-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Total Insurance Cost (calculated)"
          prefix="$"
          :value="total_insurance_fee"
          type="CURRENCY"
          disabled
        />
      </div>

      <md-subheader>Repayments</md-subheader>

      <div class="md-layout input-layout">
        <!-- NAF -->
        <validated-number-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="NAF (calculated)"
          prefix="$"
          :value="naf"
          readonly
        >
        </validated-number-input>

        <!-- Rate -->
        <validated-number-input
          class="md-layout-item md-small-size-100 md-size-10"
          label="Rate"
          suffix="%"
          v-model="submission.rate"
        >
        </validated-number-input>

        <!-- Balloon Payment -->
        <validated-number-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Balloon Amount"
          suffix="$"
          v-model="submission.balloon_amount"
        >
        </validated-number-input>

        <!-- Term -->
        <validated-number-input
          class="md-layout-item md-small-size-100 md-size-10"
          label="Term"
          v-model="submission.term"
          suffix="Months"
        >
        </validated-number-input>

        <!-- Frequency -->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-100 md-size-10 popup-menu"
          label="Frequency"
          v-model="submission.payment_frequency"
          :options="options.payment_frequency_options"
          force
        />

        <!-- Repayment Type-->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Repayment Type"
          v-model="submission.repayment_type"
          :options="options.submission_repayment_type"
          force
        />

        <!-- Monthly account keeping fee -->
        <validated-number-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Monthly Account Keeping Fee"
          v-model="submission.monthly_account_fee"
          prefix="$"
        />

        <!-- <div class="md-layout-item md-small-size-100 md-size-33" >
            <span v-if="term_in_months != null">
              ({{ term_in_months | yearsMonths }})
            </span>
          </div> -->

        <div></div>

        <!-- Repayments -->
        <validated-text-input
          class="md-layout-item md-small-size-100 md-size-100"
          label="Repayments (calculated)"
          :value="repayment_message"
          readonly
        >
        </validated-text-input>
      </div>

      <md-subheader>Status</md-subheader>
      <div class="md-layout">
        <!-- Submission Status -->
        <validated-autocomplete-input
          class="md-layout-item md-size-50"
          label="Submission Status"
          v-model="submission.status"
          required
          :options="options.submission_status_options"
          force
          limitedDropdownHeight
        />

        <!-- Response Message -->
        <validated-text-input
          class="md-layout-item md-size-50"
          label="Response Message"
          v-model="submission.response_message"
        >
        </validated-text-input>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-simple" @click="onCancel"
      >Cancel</md-button
      >

      <loading-icon-text-button
        class="md-primary"
        @click="onSave"
        icon="save"
        :loading="isSaving"
      >
        Save
      </loading-icon-text-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import EditSubmissionDetails from "./EditSubmissionDetails";
import utils from "@/components/utils/utils";
import AlertDialog from "../Dialogs/AlertDialog";

export default {
  components:{
    LoadingIconTextButton,
    ...ValidatedInputs,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    enableIncome: {
      default: false,
      type: Boolean,
    },
    submission: {
      required: true,
      type: Object | Array,
    },
    value: {
      required: true,
      type: Object | Array,
    }
  },
  watch:{
    visible(val) {
      if (val) {
        this.originalSubmission = JSON.parse(JSON.stringify(this.submission));
        this.originalApplication = JSON.parse(JSON.stringify(this.application));
        this.originalSecurity = JSON.parse(JSON.stringify(this.security));
      }
    },
    naf(value) {
      if (!!this.submission) {
        this.submission.naf = value;
      }
    },
    repayment_amount(value) {
      this.submission.repayments = value;
    },
    trade_in_asset_value(value) {
      this.security.trade_in_value = value;
    }
  },
  data(){
    return{
      isSaving: false,
      originalSubmission: null,
      originalApplication: null,
      originalSecurity: null
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      "application",
      "application_status",
      "options",
      "productLenders",
      "products",
      "security"
    ]),
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      }
    },
    isVisible:{
      get(){
        return this.visible;
      },
      set(value){
        if (!value) {
          this.resetData();
        }
        this.$emit("onCancel", value);
      }
    },
    isComplianceFail:{
      get(){
        return !this.enableIncome;
      },
      set(value){
        this.$emit("onCancel", value);
      }
    },
    isWithOtherFields(){
      let asset_types = ['Vehicle', 'Personal Secured', 'Marine', 'Leisure'];
      return asset_types.includes(this.application.loan.asset.type);
    },
    total_requested_amount() {
      let requested_amount = 0;
      switch (this.application.loan.asset.type) {
        case "Vehicle":
          requested_amount = this.float(this.application.loan.asset.vehicle.requested_amount);
          break;
        case "Personal Secured":
          requested_amount = this.float(this.application.loan.asset.secured.requested_amount);
          break;
        case "Personal Unsecured":
          requested_amount = this.float(this.application.loan.asset.unsecured.requested_amount);
          break;
        case "Marine":
          requested_amount = this.float(this.application.loan.asset.marine.requested_amount);
          break;
        case "Leisure":
          requested_amount = this.float(this.application.loan.asset.leisure.requested_amount);
          break;
        case "Cashflow":
          requested_amount = this.float(this.application.loan.asset.cashflow.requested_amount);
          break;
        case "Equipment":
          requested_amount = this.float(this.application.loan.asset.equipment.requested_amount);
          break;
      }
      let trade_in_asset_outstanding_amount = this.float(this.trade_in_asset_outstanding_amount);
      let trade_in_value = this.float(this.trade_in_asset_value);
      return requested_amount + trade_in_asset_outstanding_amount - trade_in_value;
    },
    total_fees() {
      let document_origination_fee = this.float(
        this.submission.document_origination_fee
      );
      let establishment_fee = this.float(
        this.submission.establishment_fee
      );
      let ppsr_fee = this.float(this.submission.ppsr_fee);
      let risk_fee = this.float(this.submission.risk_fee);

      return Math.round((document_origination_fee + establishment_fee + ppsr_fee + risk_fee) * 100) / 100;
    },
    total_insurance() {
      return this.application.loan.insurances.reduce(
        (sum, insurance) => sum + ((insurance.enabled && insurance.include_in_naf) ? this.float(insurance.premium) : 0),
        0
      );
    },
    total_insurance_fee() {
      return this.round(this.application.loan.insurances.reduce(
        (sum, insurance) => sum + this.float(insurance.premium),
        0
      ), 2);
    },
    naf: {
      get() {
        if (!this.application) {
          return null;
        }
        return Math.round((this.total_requested_amount + this.total_fees + this.total_insurance + this.get_lender_commission_amount) * 100) / 100;
      },
      set(value) {
        this.submission.naf = value;
      }
    },
    trade_in_asset() {
      let assets = this.application.applicants.flatMap((a) => a.assets);
      return assets.find((a) => a.has_trade_in); // this returns undefined if no asset is selected as trade in
    },
    enable_trade_in_asset_value() {
      return !!this.trade_in_asset;
    },
    enable_trade_in_asset_outstanding_amount() {
      return this.enable_trade_in_asset_value && this.trade_in_asset.has_liability;
    },
    trade_in_asset_value: {
      get() {
        return this.enable_trade_in_asset_value ? (this.trade_in_asset.value === null ? this.security.trade_in_value : this.trade_in_asset.value) : null;
      },
      set(value) {
        if (this.enable_trade_in_asset_value) {
          this.trade_in_asset.value = value;
        }
      },
    },
    trade_in_asset_outstanding_amount: {
      get() {
        return this.enable_trade_in_asset_outstanding_amount
          ? this.trade_in_asset.finance.outstanding_amount
          : null;
      },
      set(value) {
        if (this.enable_trade_in_asset_outstanding_amount) {
          this.trade_in_asset.finance.outstanding_amount = value;
        }
      },
    },
    repayment_message() {
      let periodic_payments = this.currency(this.repayment_amount);
      let frequency = this.submission.payment_frequency;
      let term = this.submission.term;
      let number_of_payments = Math.round(
        term / utils.frequencyConversionFactor("Monthly", frequency)
      );

      if (periodic_payments) {
        return `${number_of_payments} ${frequency} payments of ${periodic_payments}`;
      } else {
        return null;
      }
    },
    warnings() {
      return submissionValidation(this.application).notes;
    },
    isConsumerWithZeroSurplus() {
      let isConsumer = this.loan_type.application_type == 'consumer';
      return (!isSurplusMoreThanZero(this.application) && isConsumer);
    },
    repayment_amount() {
      if (!this.application) {
        return null;
      }
      let amount = this.submission.naf;
      let anual_rate = this.submission.rate;
      let monthly_account_fee = this.submission.monthly_account_fee;
      let term = this.submission.term;
      let repayment_frequency = this.submission.payment_frequency;
      let balloon_amount = this.submission.balloon_amount;
      let repayment_type = this.submission.repayment_type;

      return utils.calculateRepayments(
        amount,
        anual_rate,
        term,
        "Monthly",
        repayment_frequency,
        monthly_account_fee,
        balloon_amount,
        repayment_type,
      );
    },
    get_lender_commission_amount: {
      get() {
        return this.application.loan.broker_income.lender_commission && this.application.loan.broker_income.lender_commission.include_in_naf
               ? this.float(this.application.loan.broker_income.lender_commission.amount) : 0
      },
      set(value) {
          this.application.loan.broker_income.lender_commission.amount = value;
      },
    },
  },
  methods:{
    ...filters,
    async onSave() {
      this.isSaving = true;
      await this.$store.dispatch('save_application', this.application);
      let result = await this.$store.dispatch('update_submission_data', {application_id: this.application.loan.id, submission:this.submission});
      if (result) {
        this.showNotification('Success','Submission updated');
        this.originalSubmission = JSON.parse(JSON.stringify(this.submission));
        this.originalApplication = JSON.parse(JSON.stringify(this.application));
        this.originalSecurity = JSON.parse(JSON.stringify(this.security));
        // update app status after success updating submission
        if (this.submission.status === "Submitted" || this.submission.status === "Conditionally Approved" || this.submission.status === "Approved") {
          let status = "";
          switch (this.submission.status) {
            case 'Submitted':
              status = "Submitted";
              break;
            case 'Conditionally Approved':
              status = "Approved - Conditional";
              break;
            case 'Approved':
              status = "Approved";
              break;
          }
          const stage = this.application.loan.status.stage;
          if (stage != "Settlement" && stage != "Compliance") {
            try {
              await this.$store.dispatch('update_application_status', {
                application_id: this.application.loan.id,
                stage: "Broker",
                status: status,
                reason: "Other",
                comment: "",
              });
            } catch (error) {
              console.log(error);
              this.showNotification('Error', 'Error changing the status to: ' + this.submission.status);
            }
          }
        }
        this.onCancel();
      } else {
        this.showNotification('Error', 'Couldn\'t update submission.');
      }
      this.isSaving = false;
    },
    onCancel(){
      this.isVisible = false;
    },
    resetData() {
      if (this.originalSubmission) {
        Object.assign(this.submission, JSON.parse(JSON.stringify(this.originalSubmission)));
      }
      if (this.originalApplication) {
        Object.assign(this.application, JSON.parse(JSON.stringify(this.originalApplication)));
      }
      if (this.originalSecurity) {
        Object.assign(this.security, JSON.parse(JSON.stringify(this.originalSecurity)));
      }
    },
    showNotification(title, message){
      if(this.$modal.submit){
        this.$modal.submit();
      }
      this.$modal.show(AlertDialog, {
        title: title,
        message: message,
      })
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'payment_frequency_options',
        'submission_repayment_type',
        'submission_status_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  created() {
    // for existing applications where the trade in value in asset is not set
    if (this.trade_in_asset_value > 0 && this.trade_in_asset_value != this.security.trade_in_value) {
      this.security.trade_in_value = this.trade_in_asset_value;
    }
  }
}
</script>
